import { Operation } from 'shell/view-models/operation';
import { Order } from 'shell/view-models/order';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { FiltersFormService } from './types';

export const transformDataset = (values: FiltersFormService): string => {
  const { orders, ...otherValues } = values;

  const transformedFilters: OperationObject = {
    codiceServizio: {
      value: otherValues.code,
      operation: Operation.EQUALS,
    },
    descrizione: { value: otherValues.description, operation: Operation.LIKE },
  };

  const ordersToTransform = orders || {};
  const ordersMapped: Order = {
    codiceServizio: ordersToTransform.code,
    descrizione: ordersToTransform.description,
  };

  return `?${paginationListToQueryString({
    filters: transformedFilters,
    orders: ordersMapped,
  })}`;
};
